import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteItpPayload } from '@app-store/slices/companies/deleteItp'

interface TaskAction extends Action {
    payload: IDeleteItpPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.deleteItp

function* deleteItpSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/itps/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Itp deleted successfully.'
            })
            yield put(payload?.sagaCB?.onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteItpSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteItpSagaTask)
}

export default deleteItpSaga
